import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch, TypedUseSelectorHook, useSelector } from 'react-redux';

import purchasePlanReducer from './purchasePlan/purchasePlanSlice';
import settingsReducer from './settings/settingsSlice';
import carsReducer from './cars/carsSlice';
import dealersReducer from './dealers/dealersSlice';
import dealerSettingsReducer from './dealerSettings/dealerSettingsSlice';

const reducers = {
  purchasePlan: purchasePlanReducer,
  settings: settingsReducer,
  cars: carsReducer,
  dealers: dealersReducer,
  dealerSettings: dealerSettingsReducer,
};

export const rootReducer = combineReducers(reducers);

const resettableRootReducer = (
  state: ReturnType<typeof rootReducer> | undefined | any,
  action: AnyAction
) => {
  if (action.type === 'auth/logoutUser/fulfilled') {
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: resettableRootReducer,
  // devTools: false
});

export default store;

// Define type for hooks
type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export hooks
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
